import { render, staticRenderFns } from "./AvatarParticipationStatus.vue?vue&type=template&id=19ffdc78&scoped=true&"
import script from "./AvatarParticipationStatus.vue?vue&type=script&lang=js&"
export * from "./AvatarParticipationStatus.vue?vue&type=script&lang=js&"
import style0 from "./AvatarParticipationStatus.vue?vue&type=style&index=0&id=19ffdc78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ffdc78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ffdc78')) {
      api.createRecord('19ffdc78', component.options)
    } else {
      api.reload('19ffdc78', component.options)
    }
    module.hot.accept("./AvatarParticipationStatus.vue?vue&type=template&id=19ffdc78&scoped=true&", function () {
      api.rerender('19ffdc78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Invitees/AvatarParticipationStatus.vue"
export default component.exports